module.exports = __webpack_public_path__ + "img/ring_g_0_null_1@3x.a26d52d7.png";